
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import 'rxjs/Rx';
import { ElectricityContract } from '../models/electricity-contract.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class ElectricityContractService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getAll() {
        return this.http.get('api/ElectricityContract', this.getAuthHeader(true));
    }

    getFiltered(customerId: number, facilityTypeId: number) {
        return this.http.get(`api/ElectricityContract/GetFiltered/${customerId}/${facilityTypeId}`, this.getAuthHeader(true));
    }

    getElectricityContractById(ecid: number) {
        return this.http.get('api/ElectricityContract/GetElectricityContractById/' + ecid, this.getAuthHeader(true));
    }

    getElectricityContractByContractId(cid: number) {
        return this.http.get('api/ElectricityContract/GetElectricityContractByContractId/' + cid, this.getAuthHeader(true));
    }

    getElectricityContractVMByContractId(cid: number) {
        return this.http.get('api/ElectricityContract/GetElectricityContractViewModelByContractId/' + cid, this.getAuthHeader(true));
    }

    getAllByCustomer(customerId: number) {
        return this.http.get('api/ElectricityContract/GetAllByCustomer/' + customerId, this.getAuthHeader(true));
    }

    getAllForDashboard() {
        return this.http.get('api/ElectricityContract/GetAllForDashboard', this.getAuthHeader(true));
    }

    getAllForDashboardLazyLoad(limit: number, offset: number, sortby: string, contractType: string, searchQuery: any = null) {
        return this.http.get(`api/ElectricityContract/GetAllForDashboardLazyLoad/${limit}/${offset}${sortby !== "" ? "/" + sortby : "/ContractEndDate"}/${contractType}${searchQuery !== "" ? "/" + encodeURIComponent(searchQuery) : ""}`, this.getAuthHeader(true));
    }

    createUpdate(electricityContract: ElectricityContract) {
        return this.http.post('api/ElectricityContract', electricityContract, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get('api/ElectricityContract/Delete/' + id, this.getAuthHeader(true));
    }

    getEndexByDate(contractDate: string) {
        return this.http.get('api/ElectricityContract/GetEndexByDate/' + contractDate, this.getAuthHeader(true));
    }

    downloadZip(facilityTypeId: number, contractId: number) {
        return this.http.get(`/api/ContractFile/DownloadZip/${facilityTypeId}/${contractId}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    downloadPdf(facilityTypeId: number, contractId: number, contractFileId: number) {
        return this.http.get(`/api/ContractFile/DownloadPdf/${facilityTypeId}/${contractId}/${contractFileId}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    exportExcel(ids: string) {
        return this.http.post(`/api/ElectricityContract/ExportExcel`, { ids: ids }, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/electricity-contract.service.ts